import {theme, Typography} from 'antd';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {useSelector} from 'react-redux';
import {FORMAT_TYPE} from 'Utils/constants/DateFormat';
import {dateConversionIsoToLocal, isValidISO8601} from 'Utils/helpers/DateValidation';

const FieldsItem = ({fieldKey, value, csFieldMap}) => {
  const tenantConfig = useSelector((state: any) => state?.login?.tenantConfig);
  const fieldValue = fieldKey === 'transactionStatus' ? value || ' ' : value;
  const {token}: any = theme.useToken();

  return (
    <Fragment>
      {fieldKey && csFieldMap[fieldKey] && fieldValue && (
        <div
          style={{
            flex: '0 0 30%',
            borderBottom: `1px solid ${token.colorBorder}`,
            marginBottom: 8,
            paddingTop: 16,
          }}>
          <Typography.Text type="secondary">{csFieldMap[fieldKey]}</Typography.Text>
          <Typography.Text style={{display: 'block', padding: '8px 0'}}>
            {isValidISO8601(fieldValue)
              ? dateConversionIsoToLocal(
                  fieldValue,
                  FORMAT_TYPE?.DATE_TIME,
                  '',
                  tenantConfig?.locale,
                )
              : fieldValue || '-'}
          </Typography.Text>
        </div>
      )}
    </Fragment>
  );
};

FieldsItem.propTypes = {
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.string,
  csFieldMap: PropTypes.object.isRequired,
};

export default FieldsItem;
